import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getDirectSalesMediaType = createSelector(
  (state: Store) => state.dealManagement.directSales.mediaType,
  (mediaType) => mediaType,
);
